import { useSelector } from 'react-redux';
import { ApplicationState } from '../types/state';
import { UserType } from '../types/user';

export const useIsCustomUser = (): boolean => {
    const main = useSelector((state: ApplicationState) => state.main);
    return main?.userInfo?.userType === UserType.CUSTOM;
};